<template>
  <div>
    <div class="p-4">
      <div class="toolbar-card">
        <absent-letter-filter-bar
            :date="date"
            :id-class="idClass"
            :id-grade="idGrade"
            :absent-letter-status="absentLetterStatus"
            :keyword="keyword"
            @change="handleFilterChange"
        />
        <div class="student-toolbar-divider"></div>
        <absent-letter-task @constitutive="handleOpenConfigDialog" @reason-config="handleOpenReasonConfigDialog" @approve-multi="fetchApprovedMulti" @delete-multi="fetchDeleteMulti"/>
      </div>

      <div class="attendance-data-card">
        <div>
          <p class="card-title">Danh sách đơn xin nghỉ học sinh</p>
          <p class="card-subtitle">Theo dõi thông tin đơn xin nghỉ của học sinh</p>
        </div>
        <div class="card-body-table">
          <absent-letter-table
              :loading="isLoading"
              :items="items"
              @detail="handleDetail"
              @approve="fetchApprovedLetter"
              @selection-multi="handleMultipleSelection"
              @delete="fetchDeleteLetter"
          />
        </div>
      </div>

      <absent-letter-footer :limit="limit" :page="offset" :total="total" @change="handleChangePage"/>
    </div>

    <absent-letter-detail :dialog-visible="dialog.detail" ref="absentLetterDetail" @close="handleCloseDialogDetail"
                          @approve="fetchApprovedLetter"/>

    <absent-letter-config :dialog-visible="dialog.configSchool" @dialog-close="handleCloseSystemConfigSchool"
                          ref="AbsentLetterConfig"/>

    <absent-letter-reason-config :dialog-visible="dialog.reasonConfig" @dialog-close="handleCloseReasonConfig"
                                  ref="AbsentLetterReasonConfig"/>
  </div>
</template>

<script>
import AbsentLetterFilterBar from "@/absent_letter_v3/components/AbsentLetterFilterBar.vue";
import AbsentLetterTable from "@/absent_letter_v3/components/AbsentLetterTable.vue";
import AbsentLetterV3Service from "@/absent_letter_v3/services/AbsentLetterV3Service";
import AbsentLetterFooter from "@/absent_letter_v3/components/AbsentLetterFooter.vue";
import AbsentLetterDetail from "@/absent_letter_v3/components/dialog/AbsentLetterDetail.vue";
import Vue from "vue";
import AbsentLetterTask from "@/absent_letter_v3/components/AbsentLetterTask.vue";
import AbsentLetterConfig from "@/absent_letter_v3/components/dialog/AbsentLetterConfig.vue";
import AbsentLetterReasonConfig from "@/absent_letter_v3/components/dialog/AbsentLetterReasonConfig.vue";

export default {
  name: "AbsentLetterPage",
  components: {
    AbsentLetterReasonConfig,
    AbsentLetterConfig,
    AbsentLetterTask,
    AbsentLetterDetail,
    AbsentLetterFooter,
    AbsentLetterTable,
    AbsentLetterFilterBar,
  },
  data() {
    return {
      date: null,
      idClass: null,
      idGrade: null,
      absentLetterStatus: null,
      keyword: null,
      pageSize: 25,
      currentPage: 1,
      limit: 25,
      offset: 0,
      total: 0,
      items: [],
      multipleSelection: [],

      isLoading: false,
      dialog: {
        detail: false,
        configSchool: false,
        reasonConfig: false,
      }
    }
  },
  methods: {
    handleFilterChange({date, idClass, idGrade, absentLetterStatus, keyword}) {
      this.date = date
      this.idClass = idClass
      this.idGrade = idGrade
      this.absentLetterStatus = absentLetterStatus
      this.keyword = keyword
      this.currentPage = 1
      this.items = []
      this.attendanceMap = {}
      this.fetchList()
    },

    handleChangePage({page, limit}) {
      this.pageSize = limit;
      this.currentPage = page;
      this.fetchList();
    },

    async fetchList() {
      this.isLoading = true;
      try {
        this.limit = this.pageSize
        this.offset = this.currentPage;

        const res = await AbsentLetterV3Service.getAll({
          classId: this.idClass,
          gradeId: this.idGrade,
          keyword: this.keyword,
          date: this.date,
          status: this.absentLetterStatus,
          page: this.offset,
          size: this.limit
        })

        let data = res.data.data;

        this.items = data.content || [];
        this.total = data.totalElements;
      } catch (e) {
        this.$message.error('Lỗi khi tải danh sách')
      } finally {
        this.isLoading = false;
      }
    },

    fetchApprovedLetter(row) {
      this.$confirm(`Xác nhận duyệt đơn xin nghỉ "${Vue.filter('formatDate')(row.fromDate)} - ${Vue.filter('formatDate')(row.toDate)}" của học sinh "${row.nameStudent}. <br>Thao tác này không thể hoàn tác.`, "Thông báo!", {
        distinguishCancelAndClose: true,
        closeOnClickModal: false,
        dangerouslyUseHTMLString: true,
        confirmButtonText: "Xác nhận",
        cancelButtonText: "Huỷ bỏ"
      }).then(() => {
        AbsentLetterV3Service.approve({ids: [row.id]}).then(res => {
          this.$message.success(res.data.message);
          this.dialog.detail = false;
          this.fetchList();
        }).catch(err => {
          console.debug("Error approve: ", err.message);
          this.$message.error("Duyệt đơn thất bại!");
        })
      })
    },

    fetchDeleteLetter(row) {
      this.$confirm(`Xác nhận xoá đơn xin nghỉ "${Vue.filter('formatDate')(row.fromDate)} - ${Vue.filter('formatDate')(row.toDate)}" của học sinh "${row.nameStudent}". <br>Thao tác này không thể hoàn tác.`, "Thông báo!", {
        distinguishCancelAndClose: true,
        closeOnClickModal: false,
        dangerouslyUseHTMLString: true,
        confirmButtonText: "Xác nhận",
        cancelButtonText: "Huỷ bỏ"
      }).then(() => {
        AbsentLetterV3Service.delete({ids: [row.id]}).then(res => {
          this.$message.success(res.data.message);
          this.dialog.detail = false;
          this.fetchList();
        }).catch(err => {
          console.debug("Error approve: ", err.message);
          this.$message.error("Xoá thất bại!");
        })
      })
    },

    fetchApprovedMulti() {
      if (this.multipleSelection.length > 0) {
        const dataNotValid = this.multipleSelection.filter(item => item.status !== 'PENDING')

        if (dataNotValid.length > 0) {
          const desc = dataNotValid
              .map(item => `- ${item.nameStudent || ""} (${Vue.filter('formatDate')(item.createdDate)}): ${item.status === 'APPROVED' ? 'Đã duyệt' : 'Từ chối'}`)
              .join("<br>");

          this.$message({
            type: "error",
            message: `Chỉ được duyệt các đơn ở trạng thái "Đang chờ". Không thể duyệt các đơn sau:<br>${desc}`,
            dangerouslyUseHTMLString: true,
          });
        } else {
          this.$confirm(`Xác nhận duyệt các đơn xin nghỉ đã chọn. <br>Thao tác này không thể hoàn tác.`, "Thông báo!", {
            distinguishCancelAndClose: true,
            closeOnClickModal: false,
            dangerouslyUseHTMLString: true,
            confirmButtonText: "Xác nhận",
            cancelButtonText: "Huỷ bỏ"
          }).then(() => {
            const ids = this.multipleSelection.map((item) => {
              return item.id;
            })
            AbsentLetterV3Service.approve({ids: ids}).then(res => {
              this.$message.success(res.data.message);
              this.dialog.detail = false;
              this.fetchList();
            }).catch(err => {
              console.debug("Error approve: ", err.message);
              this.$message.error("Duyệt đơn thất bại!");
            })
          })
        }
      } else {
        this.$message.error("Chưa có đơn được chọn!")
      }
    },

    fetchDeleteMulti() {
      if (this.multipleSelection.length > 0) {
        const dataNotValid = this.multipleSelection.filter(item => item.status === 'APPROVED');

        if (dataNotValid.length > 0) {
          const desc = dataNotValid
              .map(item => `- ${item.nameStudent || ""} (${Vue.filter('formatDate')(item.createdDate)}): Đã duyệt`)
              .join("<br>");

          this.$message({
            type: "error",
            message: `Chỉ được xoá các đơn ở trạng thái "Đang chờ". Không thể xoá các đơn sau:<br>${desc}`,
            dangerouslyUseHTMLString: true,
          });
        } else {
          this.$confirm(`Xác nhận xoá các đơn xin nghỉ đã chọn. <br>Thao tác này không thể hoàn tác.`, "Thông báo!", {
            distinguishCancelAndClose: true,
            closeOnClickModal: false,
            dangerouslyUseHTMLString: true,
            confirmButtonText: "Xác nhận",
            cancelButtonText: "Huỷ bỏ"
          }).then(() => {
            const ids = this.multipleSelection.map((item) => {
              return item.id;
            })
            AbsentLetterV3Service.approve({ids: ids}).then(res => {
              this.$message.success(res.data.message);
              this.dialog.detail = false;
              this.fetchList();
            }).catch(err => {
              console.debug("Error approve: ", err.message);
              this.$message.error("Xoá đơn thất bại!");
            })
          })
        }
      } else {
        this.$message.error("Chưa có đơn được chọn!")
      }
    },

    handleDetail(id) {
      this.dialog.detail = true;
      this.$refs.absentLetterDetail.initialData(id);
    },

    handleCloseDialogDetail() {
      this.dialog.detail = false;
    },

    handleOpenConfigDialog() {
      this.dialog.configSchool = true;
      this.$refs.AbsentLetterConfig.getDataInitial();
    },
    handleCloseSystemConfigSchool() {
      this.dialog.configSchool = false;
    },
    handleOpenReasonConfigDialog() {
      this.dialog.reasonConfig = true;
      this.$refs.AbsentLetterReasonConfig.fetchList();
    },
    handleCloseReasonConfig() {
      this.dialog.reasonConfig = false;
    },
    handleMultipleSelection(values) {
      this.multipleSelection = values;
    }
  }
}
</script>

<style scoped lang="scss">
.p-4 {
  padding: 1rem;
}

.toolbar-card {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
  padding: 16px 20px;
  background: #ffffff;
  border: 1px solid #e8edf4;
  border-radius: 12px;
  box-shadow: 0 4px 14px rgba(31, 45, 61, 0.06);
  margin-bottom: 16px;
}

/* ─── STYLE CHO KHỐI CARD DỮ LIỆU TABS + TABLE ─────────────────────── */
.attendance-data-card {
  background-color: #ffffff;
  border-radius: 12px;
  padding: 16px;
  margin-top: 16px; /* Khoảng cách thông thoáng với Filter Bar phía trên */
  margin-bottom: 16px; /* Khoảng cách với Footer Action phía dưới */
  border: 1px solid #f1f5f9;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.04); /* Đổ bóng nhẹ sang trọng */
}

/* Đẩy nút Tab điều hướng về bên phải trong Header Card */
.card-header-tabs {
  display: flex;
  justify-content: flex-end;
}

.card-body-table {
  margin-top: 20px;
  width: 100%;
}

.card-title {
  margin: 0 0 4px;
  font-size: 16px;
  font-weight: 700;
  color: #1e293b;
}

.card-subtitle {
  margin: 0;
  font-size: 13px;
  line-height: 1.5;
  color: #64748b;
}

.student-toolbar-divider {
  width: 1px;
  height: 24px;
  background: #e2e8f0;
  margin: 0 20px;
  flex-shrink: 0;
}
</style>
